// base
import React from 'react';

// style
import { StyledBasicModalV2 } from './style';

// libraries
import { Modal, Typography } from '@mui/material';

export interface BasicModalV2Props {
  children?: React.ReactNode;
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  width?: string | number;
  height?: string | number;
  isScroll?: boolean;
}

/**
 * ==============================================================================================
 * 2024.10.25 - KDONG
 *
 * BasicModal을 베이스로 TS로 변경한 컴포넌트입니다.
 *
 * @params {BasicModalV2Props} props
 * ==============================================================================================
 */
export const BasicModalV2: React.FC<BasicModalV2Props> = ({
  open,
  onClose,
  children,
  title,
  description,
  width = 400,
  height = 200,
  isScroll = false
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <StyledBasicModalV2 $width={width} $height={height} $isScroll={isScroll}>
        {children || (
          <>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {title || 'Text in a modal'}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {description || 'Duis mollis, est non commodo luctus, nisi erat porttitor ligula.'}
            </Typography>
          </>
        )}
      </StyledBasicModalV2>
    </Modal>
  );
};
